import { render, staticRenderFns } from "./writeDetail.vue?vue&type=template&id=0c4d02ec&scoped=true"
import script from "./writeDetail.vue?vue&type=script&lang=js"
export * from "./writeDetail.vue?vue&type=script&lang=js"
import style0 from "./writeDetail.vue?vue&type=style&index=0&id=0c4d02ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4d02ec",
  null
  
)

export default component.exports